<template>
  <div
    id="multiSensorHiL"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: $i18n.locale === 'en-US',
    }"
  >
    <!-- banner -->
    <div
      id="multiSensorHiLModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="multiSensorHiLModule1Text" class="gaiAModule1">
        <div id="multiSensorHiLModule1TextText1" class="module1">
          {{ $t(`${i18nKey}.title`) }}
        </div>
        <div id="multiSensorHiLModule1TextText2" class="module1">
          {{ $t(`${i18nKey}.subtitle`) }}
        </div>
      </div>
    </div>
    <!-- 平台特点 -->
    <div class="feature">
      <div class="h1 wow animate__animated animate__fadeInUp">
        {{ $t(`${i18nKey}.feature.title`) }}
      </div>
      <div class="featureList wow animate__animated animate__fadeInUp">
        <div class="left">
          <div class="text">
            <div class="icon">
              <img src="@/static/img/feature1Icon.png" alt="" />
            </div>
            <div class="titil1">
              {{ $t(`${i18nKey}.feature.list[0].title`) }}
            </div>
            <div class="titil2">
              {{ $t(`${i18nKey}.feature.list[0].content`) }}
            </div>
          </div>
          <div class="img">
            <img src="@/static/img/feature1RightTop.png" alt="" />
          </div>
        </div>
        <div style="width: 1.25rem"></div>
        <div class="right">
          <div class="text">
            <div class="icon">
              <img src="@/static/img/feature2Icon.png" alt="" />
            </div>
            <div class="titil1">
              {{ $t(`${i18nKey}.feature.list[1].title`) }}
            </div>
            <div class="titil2">
              {{ $t(`${i18nKey}.feature.list[1].content`) }}
            </div>
          </div>
          <div class="img">
            <img src="@/static/img/feature2RightTop.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 重器矩阵 -->
    <div class="matrix_bg">
      <div class="matrix wow animate__animated animate__fadeInUp">
        <div id="title">{{ $t(`${i18nKey}.matrix.title`) }}</div>
        <p>{{ $t(`${i18nKey}.matrix.subtitle`) }}</p>
        <el-table
          :show-header="false"
          :data="$t(`${i18nKey}.tableData`)"
          style="width: 100%; margin: 0 auto; border: 1px solid #282553"
          :cell-style="tableCellStyle"
        >
          <el-table-column fixed align="center" prop="col0"> </el-table-column>
          <el-table-column align="center" prop="col1"> </el-table-column>
          <el-table-column align="center" prop="col2"> </el-table-column>
          <el-table-column align="center" prop="col3"> </el-table-column>
          <el-table-column align="center" prop="col4"> </el-table-column>
          <el-table-column align="center" prop="col5"> </el-table-column>
          <el-table-column align="center" prop="col6"> </el-table-column>
          <el-table-column align="center" prop="col7"> </el-table-column>
          <el-table-column align="center" prop="col8"> </el-table-column>
          <el-table-column align="center" prop="col9" width="120">
          </el-table-column>
          <el-table-column align="center" prop="col10"> </el-table-column>
          <el-table-column align="center" prop="col11"> </el-table-column>
        </el-table>
      </div>
    </div>

    <div id="multiSensorHiLFooter">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
  },
  components: {
    FooterComponents,
  },
  updated() {
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
  },
  data() {
    return {
      i18nKey: "ecosphereModelSharePlatform",
      imageUrl1: require("@/static/img/modelSharePlatform_bg.png"),
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  methods: {
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 || columnIndex === 0) {
        return "background:#0f132d;";
      }
      // 表格的列做处理
      switch (columnIndex) {
        case 1:
          if (rowIndex === 1) {
            return "background:#C22F41;";
          } else if (rowIndex === 2) {
            return "background:#EA3951;";
          } else if (rowIndex === 3) {
            return "background:#532A4B;";
          } else if (rowIndex === 4) {
            return "background:rgba(83, 42, 75, 0.70);";
          }
          break;
        case 2:
          if (rowIndex === 4) {
            return "background:#312F42;";
          } else if (rowIndex === 5) {
            return "background:rgba(89, 19, 133, 0.50);";
          }
          return "background:rgba(0, 93, 183, 0.70);";
          break;
        case 3:
          if (rowIndex === 1) {
            return "background:rgba(66, 50, 134, 0.70);";
          } else if (rowIndex === 2) {
            return "background:#043872;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          } else if (rowIndex === 5) {
            return "background:#005DB7;";
          }
          break;
        case 4:
          if (rowIndex === 1) {
            return "background:rgba(66, 50, 134, 0.70);";
          } else if (rowIndex === 2) {
            return "background:#6C46F6;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          } else if (rowIndex === 5) {
            return "background:#005DB7;";
          }
          break;
        case 5:
          if (rowIndex === 1) {
            return "background:#005DB7;";
          } else if (rowIndex === 2) {
            return "background:#6C46F6;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          }
          break;
        case 6:
          if (rowIndex === 1) {
            return "background:#005DB7;";
          } else if (rowIndex === 2) {
            return "background:#6C46F6;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          }
          break;
        case 7:
          if (rowIndex === 1) {
            return "background:rgba(66, 50, 134, 0.70);";
          } else if (rowIndex === 2) {
            return "background:#043872;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          } else if (rowIndex === 5) {
            return "background:#005DB7;";
          }
          break;
        case 8:
          if (rowIndex === 1) {
            return "background:rgba(66, 50, 134, 0.70);";
          } else if (rowIndex === 2) {
            return "background:#043872;";
          } else if (rowIndex === 3) {
            return "background:#A553C1;";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          } else if (rowIndex === 5) {
            return "background:#005DB7;";
          }
          break;
        case 9:
          if (rowIndex === 1) {
            return "background:#005DB7;";
          } else if (rowIndex === 2) {
            return "background:#591385;";
          } else if (rowIndex === 3) {
            return "background:rgba(69, 65, 134, 0.50);";
          }
          break;
        case 10:
          if (rowIndex === 1) {
            return "background:#005DB7;";
          } else if (rowIndex === 2) {
            return "background:#591385;";
          }
          break;
        case 11:
          if (rowIndex === 1) {
            return "background:rgba(66, 50, 134, 0.70);";
          } else if (rowIndex === 2) {
            return "background:#043872;";
          } else if (rowIndex === 3) {
            return "background:rgba(89, 19, 133, 0.50);";
          } else if (rowIndex === 4) {
            return "background:#454186;";
          } else if (rowIndex === 5) {
            return "background:#005DB7;";
          }
          break;
        default:
          break;
      }
      // 给所有单元格设置背景颜色
      return "background: #151535";
    },
  },
};
</script>

<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;

    #multiSensorHiLModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  .feature {
    padding-bottom: 5.4375rem;
    background: url("@/static/img/feature_bg.png") no-repeat 100% 100%;
    background-size: cover;

    .h1 {
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 4.8613rem 0 3rem;
    }

    .featureList {
      display: flex;
      justify-content: center;
      align-items: stretch;

      .text {
        // width: 35.5rem;
        width: 32.75rem;
        // border-radius: 0.25rem;
        // background: linear-gradient(
        //   193deg,
        //   rgba(128, 186, 240, 0.1) 22.73%,
        //   rgba(16, 28, 60, 0.1) 72.38%
        // );
        // box-shadow: 0px 1.5rem 2.5rem 0px rgba(12, 12, 12, 0.4);
        // backdrop-filter: blur(0.625rem);
        // padding: 2rem 0 2rem 2.75rem;
        padding: 2rem 2.75rem;

        .icon {
          width: 4rem;
          width: 4rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .titil1 {
          color: rgba(255, 255, 255, 0.85);
          font-size: 1.5rem;
          font-style: normal;
          font-weight: 600;
          line-height: 2.5rem;
          text-align: left;
          margin: 1.0625rem 0 0.5rem;
        }

        .titil2 {
          color: rgba(255, 255, 255, 0.65);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 1.625rem;
        }
      }

      .left,
      .right {
        position: relative;
        border-radius: 0.25rem;
        background: linear-gradient(
          193deg,
          rgba(128, 186, 240, 0.1) 22.73%,
          rgba(16, 28, 60, 0.1) 72.38%
        );
        box-shadow: 0px 1.5rem 2.5rem 0px rgba(12, 12, 12, 0.4);
        backdrop-filter: blur(0.625rem);

        .img {
          position: absolute;
          top: 0;
          right: 0;
          width: 10rem;
          height: 11.5625rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .matrix_bg {
    background: url("@/static/img/matrix_bg.png") no-repeat 100% 100%;
    background-size: cover;
    padding: 6.25rem 3.8125rem;

    :deep(.el-table::before) {
      height: 0;
    }

    :deep(.el-table__fixed::before) {
      height: 0;
    }

    :deep(.el-table tr) {
      background-color: transparent;
    }

    :deep(.el-table td.el-table__cell) {
      border: 1px solid #282553;
    }

    :deep(.cell) {
      word-break: break-word;
    }

    .matrix {
      text-align: center;

      #title {
        color: rgba(255, 255, 255, 0.85);
        text-align: center;
        font-size: 2.25rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      p {
        color: rgba(255, 255, 255, 0.65);
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.625rem;
        margin: 1rem 0 3rem;
      }

      :deep(.el-table) {
        background-color: #0e132c;
      }

      :deep(.el-table__body) {
        color: #fff;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        text-transform: capitalize;
      }

      :deep(.el-table__body:hover tr:hover > td) {
        background-color: transparent;
      }
    }
  }
}

.en {
  #multiSensorHiL .feature .featureList .text .titil2 {
    line-height: 1.5 !important;
  }
  :deep(.el-table__body) {
    .cell {
      line-height: 1.5 !important;
    }
  }
}
</style>
